module.exports = "../study/imgs/maps/Tokyo/S8/Hazard/Beach/Tokyo_Beach_MIROC5_RCP85_End.png";